import React, { useState } from "react";
import DomainSeoHelmet from "../agentic/DomainSeoHelmet";
import DomainHiddenSeoContent from "../agentic/DomainHiddenSeoContent";
import DomainUseCaseCard, { DOMAIN_PAGE_STYLES } from "../agentic/domainUseCaseLayout";
import UseCaseIndexGrid from "../agentic/UseCaseIndexGrid";
import RpaProcessFlow from "./RpaProcessFlow";
import {
  PUBLIC_SECTOR_DOMAIN_INTRO,
  PUBLIC_SECTOR_GROUPS,
  PUBLIC_SECTOR_USE_CASES_SEO,
  PUBLIC_SECTOR_DOMAIN_FAQS,
  PUBLIC_SECTOR_ITEM_LIST_JSONLD,
  PUBLIC_SECTOR_BREADCRUMB_JSONLD,
  PUBLIC_SECTOR_WEBPAGE_JSONLD,
  PUBLIC_SECTOR_FAQ_JSONLD,
} from "../../data/rpa/public-sector-government-domainUseCases";

function UseCaseCard({ useCase }) {
  return (
    <DomainUseCaseCard
      useCase={useCase}
      flow={<RpaProcessFlow useCase={useCase} />}
    />
  );
}

function GroupSection({ group }) {
  const cases = PUBLIC_SECTOR_USE_CASES_SEO.filter((uc) => uc.groupId === group.id);
  if (!cases.length) return null;
  return (
    <section id={group.id} className="fin-section" aria-labelledby={`${group.id}-heading`}>
      <h2 id={`${group.id}-heading`}>{group.label}</h2>
      <div className="fin-list">
        {cases.map((uc) => (
          <UseCaseCard key={uc.id} useCase={uc} />
        ))}
      </div>
    </section>
  );
}

export default function PublicSectorRpaDomainContent() {
  const [activeFilter, setActiveFilter] = useState("all");
  const visibleGroups =
    activeFilter === "all"
      ? PUBLIC_SECTOR_GROUPS
      : PUBLIC_SECTOR_GROUPS.filter((group) => group.id === activeFilter);

  return (
    <div className="fin-page">
      <DomainSeoHelmet
        intro={PUBLIC_SECTOR_DOMAIN_INTRO}
        domainSlug="public-sector-government-domain"
        basePath="/rpa-use-cases"
        useCaseCount={PUBLIC_SECTOR_USE_CASES_SEO.length}
        groupCount={PUBLIC_SECTOR_GROUPS.length}
        itemListJsonLd={PUBLIC_SECTOR_ITEM_LIST_JSONLD}
        faqJsonLd={PUBLIC_SECTOR_FAQ_JSONLD}
        breadcrumbJsonLd={PUBLIC_SECTOR_BREADCRUMB_JSONLD}
        webPageJsonLd={PUBLIC_SECTOR_WEBPAGE_JSONLD}
        keywords="Public Sector & Government automation, document AI + RPA, workflow automation, robotic process automation India UAE KSA UK USA"
        sectionLabel=""
      />
      <style>{DOMAIN_PAGE_STYLES}</style>
      <header className="fin-hero">
        <div className="fin-hero-inner">
          <h1>{PUBLIC_SECTOR_DOMAIN_INTRO.title}</h1>
          {PUBLIC_SECTOR_DOMAIN_INTRO.content ? <p>{PUBLIC_SECTOR_DOMAIN_INTRO.content}</p> : null}
        </div>
      </header>
      <UseCaseIndexGrid
        useCases={PUBLIC_SECTOR_USE_CASES_SEO}
        groups={PUBLIC_SECTOR_GROUPS}
        heading="Public Sector & Government Use Cases"
        onFilterChange={setActiveFilter}
      />
      <div className="fin-wrap">
        {visibleGroups.map((group) => (
          <GroupSection key={group.id} group={group} />
        ))}
      </div>
      <DomainHiddenSeoContent
        domainTitle={PUBLIC_SECTOR_DOMAIN_INTRO.title}
        domainFaqs={PUBLIC_SECTOR_DOMAIN_FAQS}
        useCases={PUBLIC_SECTOR_USE_CASES_SEO}
      />
    </div>
  );
}

